import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  useToggle,
  Flex,
  ChevronDownIcon,
  ChevronRightIcon,
  ThemedComponentWrapper
} from '@blockanalitica/ui';
import { NavigationData } from './Layout';
import { ThemedComponentWrapperProps } from '@blockanalitica/ui/package/types/src/theme/ThemedComponentWrapper';
import { NavLink } from 'react-router-dom';

export interface NavigationItemProps extends Partial<ThemedComponentWrapperProps> {
  variant?: 'primary' | 'secondary' | 'home' | 'glossary';
  item: NavigationData;
}

export default function NavigationItem({ item, ...rest }: NavigationItemProps) {
  const [menuIsOpen, toggleMenu] = useToggle(false);
  const hasChilds = item.subMenu !== undefined;
  const location = useLocation();

  const AsComponent = hasChilds ? 'div' : NavLink;

  useEffect(() => {
    if (location.pathname.includes(item.linkTo)) {
      toggleMenu(true);
      return;
    }

    toggleMenu(false);
  }, [item.linkTo, location.pathname, toggleMenu]);

  return (
    <>
      <ThemedComponentWrapper
        name="navigationItem"
        // @ts-ignore
        as={AsComponent}
        to={item.linkTo}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onClick={hasChilds ? () => toggleMenu() : undefined}
        {...rest}>
        <Flex gap="2xs">
          {item.icon}
          {item.title}
        </Flex>

        {hasChilds ? (
          menuIsOpen ? (
            <ChevronDownIcon size={14} />
          ) : (
            <ChevronRightIcon size={14} />
          )
        ) : null}
      </ThemedComponentWrapper>

      {hasChilds && menuIsOpen ? (
        <Flex role="menu" flexDirection="column" gap="3xs">
          {item.subMenu.map((item, index) => (
            <NavigationItem
              variant="secondary"
              key={item.title + '_' + index}
              item={item}
            />
          ))}
        </Flex>
      ) : null}
    </>
  );
}
